export const data = () => {
    $(function () {
        const ValueProcessInit = () => {
            const value_box__process = $('.value-box__process');
            if (value_box__process.length > 0) {

                value_box__process.map((a, b) => {
                    const _ = $(b);
                    const data_percent = _.attr('data-value-percent');
                    // style
                    _.css({
                        '--value-percent': data_percent
                    });
                });

                $(window).on('load scroll', function () {
                    const {
                        scrollY,
                        innerHeight
                    } = window;
                    value_box__process.map((a, b) => {
                        const _ = $(b);
                        const {
                            top
                        } = _.offset();
                        if (top < scrollY + innerHeight - 60 && !_.hasClass('run')) {
                            _.addClass('run');
                        };
                    });
                });
            }
        };
        ValueProcessInit();

        // odometer
        const OdometerInit = () => {
            const odometer = $('.odometer');
            $(window).on('load scroll', function () {
                const {
                    scrollY,
                    innerHeight
                } = window;
                odometer.map((a, b) => {
                    const _ = $(b);
                    const {
                        top
                    } = _.offset();
                    if (top < scrollY + innerHeight - 60 && !_.hasClass('run')) {
                        const num = _.attr('data-onumber');
                        _.html(num);
                        _.addClass('run');
                    };
                });
            });
        };
        OdometerInit();
    });
}